import { getRequest, postRequest, patchRequest, deleteRequest } from "./ApiInstence";

// =====================================================================
// PROJECT CRUD
// =====================================================================
// Create project
export const createProjectApi = (data) =>
  postRequest("projects/", data);

// List projects
export const listProjectsApi = () =>
  getRequest("projects/list/");

// Start full SEO check (deducts credits)
export const startSeoCheckApi = (projectId) =>
  postRequest("start-seo-check/", { project_id: projectId });

// Delete project
export const deleteProjectApi = (id) =>
  deleteRequest(`projects/delete/${id}/`);

// Edit project
export const editProjectApi = (id, data) =>
  patchRequest(`projects/edit/${id}/`, data);

// Extra project info
export const projectExtraInfoApi = (id) =>
  getRequest(`project/${id}/extra-info/`);

// =====================================================================
// KEYWORD RANKING
// =====================================================================
// Manual keyword check (button click → 5 credits)
export const checkKeywordRankingApi = (data) =>
  postRequest("keyword/check/", data);

// Update project schedule for auto keyword checking
export const setProjectScheduleApi = (projectId, data) =>
  postRequest(`project/${projectId}/schedule/`, data);

// =====================================================================
// WEBSITE CRAWLER & SEO ANALYSIS
// =====================================================================
// Step 1: Crawl website to discover pages
export const crawlWebsiteApi = (data) =>
  postRequest("projects/crawl/", data);

// Step 2: Get discovered pages
export const getDiscoveredPagesApi = (projectId, pageSize = 1000) =>
  getRequest(`projects/${projectId}/discovered-pages/?page_size=${pageSize}`);

// Step 3: Select pages for analysis
export const selectPagesForAnalysisApi = (data) =>
  postRequest("projects/select-pages/", data);

// Step 4: Run SEO analysis
export const runSeoAnalysisApi = (data) =>
  postRequest("projects/run-analysis/", data);

// Get SEO analysis results
export const getSeoAnalysisResultsApi = (projectId) =>
  getRequest(`projects/${projectId}/analysis-results/`);

// Get domain-level SEO results
export const getDomainLevelSeoResultsApi = (projectId) =>
  getRequest(`projects/${projectId}/domain-seo/`);

// Get combined SEO analysis results
export const getSeoAnalysisResultsCombinedApi = (projectId) =>
  getRequest(`projects/${projectId}/analysis-results-combined/`);

// Get individual SEO result
export const getIndividualSeoResultApi = (resultId) =>
  getRequest(`seo-result/${resultId}/`);

// Get SEO analysis runs (historical)
export const getSeoAnalysisRunsApi = (projectId) =>
  getRequest(`projects/${projectId}/seo-runs/`);

// Get SEO run details
export const getSeoRunDetailsApi = (projectId, runId) =>
  getRequest(`projects/${projectId}/seo-runs/${runId}/`);

// Get domain all scores (calculates overall score)
export const getDomainAllScoresApi = (projectId) =>
  getRequest(`score/domain/${projectId}/all/`);

// Get page all scores (calculates overall score)
export const getPageAllScoresApi = (projectId, pageId) =>
  getRequest(`score/page/${projectId}/${pageId}/all/`);
